"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var keys = function keys(value) {
  return value ? Object.keys(value) : [];
};

exports.default = keys;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/structure/plain/keys.js
 ** module id = 1262
 ** module chunks = 0
 **/